import { Divider, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import dayjs from "dayjs";
import { useSelector } from 'react-redux';
import { getEOCConfig } from '../../../reducer/eocConfigSlice';
import DataGridMyEOC from './DataGridMyEOC';
import DetailActivity from '../EOCActivity/DetailActivity';

function EOCDetails({ eocData, activityData, setIsHidden }) {

    const eocConfig = useSelector(getEOCConfig);
    const [openDetail, setOpenDetail] = useState(false);
    const [dataActivity, setDataActivity] = useState();

    const getEOCDataTitle = () => {
        let data = {
            org_name: "",
            org_name_title: "",
        };
        if (eocData?.org_level === "01") {
            data.org_name += eocData?.org_name;
            data.org_name_title += "ประเทศ";
        } else if (eocData?.org_level === "02") {
            data.org_name += eocData?.org_name;
            data.org_name_title += "เขต";
        } else if (eocData?.org_level === "03") {
            data.org_name += eocData?.province_name;
            data.org_name_title += "จังหวัด";
        } else if (eocData?.org_level === "04") {
            data.org_name += eocData?.amphur_name + " " + eocData?.province_name;
            data.org_name_title += "อำเภอ";
        }
        return data;
    };

    const startEOCHistory = (data) => {
        let startEOCHistory = dayjs(data).locale("th").format("DD MMMM YYYY");
        return startEOCHistory;
    };

    const handleClickDetail = (row) => {
        setOpenDetail(true);
        setDataActivity(row);
        if (setIsHidden) {
            setIsHidden(true);
        }
    };

    useEffect(() => {
        if (setIsHidden) {
            if (openDetail) {
                setIsHidden(true);
            } else {
                setIsHidden(false);
            }
        }
    }, [openDetail, setIsHidden])

    return (
        <div>
            <Typography variant="body2" className='text-[#D48061]'>
                {getEOCDataTitle().org_name_title}
            </Typography>
            <Typography variant="body1">{getEOCDataTitle().org_name}</Typography>
            <Typography variant="body2" sx={{ marginTop: "10px" }} className='text-[#D48061]'>
                วันที่เปิด EOC
            </Typography>
            <Typography variant="body1">{startEOCHistory(eocData?.create_timestamp)}</Typography>
            <Typography variant="body1" sx={{ marginTop: "10px" }}>
                รายละเอียด
            </Typography>
            <Divider />
            <div className="h-96 mb-2 sm:ml-0 md:ml-4 lg:ml-8">
                <Typography
                    className="mt-4"
                    sx={{
                        color: "#D48061",
                    }}
                    variant="subtitle2"
                >
                    ผู้บังคับบัญชาเหตุการณ์
                </Typography>
                <Typography variant="body1">
                    {eocData?.incident_commander?.ic_name}
                </Typography>
                <Typography
                    className="mt-4 mb-1"
                    sx={{
                        color: "#D48061",
                    }}
                    variant="subtitle2"
                >
                    เจ้าหน้าที่เปิด EOC
                </Typography>

                <div className='w-full items-center grid gap-1 xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-8 lg:grid-cols-12'>
                    <Typography variant="body2" className='col-span-1 w-full'>ชื่อ:</Typography>
                    <Typography variant="body1" className='col-span-11 w-full'>
                        {eocData?.creator_name}
                    </Typography>
                    <Typography variant="body2" className='col-span-1 w-full mt-2 md:mt-0'>โทรศัพท์:</Typography>
                    <Typography variant="body1" className='col-span-11 w-full'>
                        {eocData?.phone}
                    </Typography>
                    <Typography variant="body2" className='col-span-1 w-full mt-2 md:mt-0'>อีเมล:</Typography>
                    <Typography variant="body1" className='col-span-11 w-full'>
                        {eocData?.email}
                    </Typography>
                    <Typography variant="body2" className='col-span-1 w-full mt-2 md:mt-0'>หน่วยงาน:</Typography>
                    <Typography variant="body1" className='col-span-11 w-full'>
                        {eocData?.org_name}
                    </Typography>
                </div>

                <Typography
                    className="mt-4 mb-1"
                    sx={{
                        color: "#D48061",
                    }}
                    variant="subtitle2"
                >
                    หน่วยงานที่มีส่วนร่วม
                </Typography>
                <div
                    className="w-full grid gap-3 xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
                >
                    {eocData?.participating_org?.map(
                        (dataparticipating, index) => (
                            <Typography
                                key={index}
                                sx={{
                                    border: "1px solid #ccc",
                                    display: "flex",
    
                                }}
                                className='rounded p-3'
                            >
                                {
                                    <span>
                                        {dataparticipating.po_type_name}
                                        <br />
                                        {eocConfig.config?.participating_org_type.map(
                                            (dataconf, index) => (
                                                <Typography
                                                    key={index}
                                                    variant="body1"
                                                    component="span"
                                                >
                                                    {dataparticipating.po_type_id ===
                                                        dataconf.po_type_id ? (
                                                        <Typography
                                                            variant="body2"
                                                            component="span"
                                                            sx={{ color: '#757575' }}
                                                        >
                                                            เช่น {dataconf.example.toString().replaceAll(",", " ")}
                                                        </Typography>
                                                    ) : (
                                                        <></>
                                                    )}
                                                </Typography>
                                            )
                                        )}
                                    </span>
                                }
                            </Typography>
                        )
                    )}
                </div>
                <div>
                    {activityData ? <>
                        {activityData?.length !== 0 ? (
                            <div>
                                <Typography
                                    className="mt-4 mb-1 text-[#D48061]"
                                    variant="subtitle2"
                                >
                                    บันทึกกิจกรรม
                                </Typography>
                                <DataGridMyEOC activityData={true} rows={activityData ? activityData : []} handleClickDetail={handleClickDetail} />
                            </div>
                        ) : (
                            <div>
                                <Typography
                                    className="mt-4 mb-1 text-[#D48061]"
                                    variant="subtitle2"
                                >
                                    บันทึกกิจกรรม
                                </Typography>
                                <Typography variant="body1">ไม่มีข้อมูลกิจกรรม</Typography>
                            </div>
                        )}
                    </> : <></>}
                </div>
            </div>
            <DetailActivity
                open={openDetail}
                setOpen={setOpenDetail}
                dataActivity={dataActivity}
            />
        </div>
    )
}

export default EOCDetails